import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { AddToPhotos, InsertChart } from "@mui/icons-material";

export interface AddSectionBarProps {
  disabled: boolean;
  onClickLoadChart: () => void;
  onClickAddChart: () => void;
}

export const AddSectionBar = ({
  disabled,
  onClickLoadChart,
  onClickAddChart
}: AddSectionBarProps): JSX.Element => {
  return (
    <Wrapper>
      <MenuBackground disabled={disabled}>
        <SectionWrapper>
          <HoverableButton
            disabled={disabled}
            aria-label="add chart"
            onClick={onClickAddChart}
          >
            <AddToPhotos />
          </HoverableButton>
          <StyledText variant="caption">Add Chart</StyledText>
        </SectionWrapper>
        <SectionWrapper>
          <HoverableButton
            disabled={disabled}
            aria-label="load chart"
            onClick={onClickLoadChart}
          >
            <InsertChart />
          </HoverableButton>
          <StyledText variant="caption">Load Chart</StyledText>
        </SectionWrapper>
      </MenuBackground>
    </Wrapper>
  );
};

// Set the height to include the text that floats underneath the menu bar.
// So that other objects can't overlap.
const Wrapper = styled("div")`
  height: 75px;
`;

const MenuBackground = styled("div")<{ disabled: boolean }>`
  display: flex;
  flex-direction: row;
  background: ${props =>
    props.disabled ? "rgba(0, 0, 0, 0.26)" : "rgba(25, 23, 63, 0.9)"};
  box-shadow: 0 4px 4px 0 #00000040;
  width: 152px;
  height: 51px;
  border-radius: 5px;
  justify-content: space-evenly;
  align-items: center;

  // Add a separator between every section of the menu
  div:not(:first-child) {
    border-left: 1px solid rgba(255, 255, 255, 0.17);
  }
`;

// Each action button should be centrally aligned
const SectionWrapper = styled("div")`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
  user-select: none;
`;

// each button should have a hover effect
const HoverableButton = styled("button")`
  display: flex;
  padding: ${({ theme }) => theme.spacing(1)};
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: none;
  color: white;
  background-color: unset;
  cursor: pointer;
  width: 42px;
  height: 42px;

  :hover {
    background-color: rgba(0, 0, 0, 0.33);
  }

  :disabled {
    background-color: unset;
    pointer-events: none;
  }
`;

const StyledText = styled(Typography)`
  color: black;
  position: absolute;
  font-size: 12px;
  // The text should be completely underneath the menu bar, as per design
  top: calc(100% + 3px);
  white-space: nowrap;
  text-align: center;
`;
